import React, { useEffect, useState } from "react";
import _, { orderBy } from "lodash";
import Button from "../../Shared/Button";
import SelectField from "../../Shared/SelectField";
import Select, { components } from "react-select";
import { getAllSMSTemplates, getManualSmsTemplates } from "../../../services/smsTemplates";
import { smsTemplatesSorter } from "../../../utils";

const Input = (props) => {
  return <components.Input {...props} />;
};

const customSelectStyles = {
  control: (base) => ({
    ...base,
    borderRadius: 0,
    height: 30,
    minHeight: 30,
  }),
};

const ManualSms = ({ isSending, onSend, isRTNoteFilled = false }) => {
  const [errorMessage, setErrorMessage] = useState(null);
  const [templates, setTemplates] = useState([]);
  const [tplOptions, setTplOptions] = useState([]);
  const [tplSelectedOptions, setTplSelectedOptions] = useState([]);
  const [tplContent, setTplContent] = useState("");
  const [templateSets, setTemplateSets] = useState([]);
  const [selectedSMSTemplateSetId, setSelectedSMSTemplateSetId] = useState("");
  const [showBookingSMSTemplateSetsDropdown, setShowBookingSMSTemplateSetsDropdown] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line no-template-curly-in-string
    setShowBookingSMSTemplateSetsDropdown(tplContent.includes("${patientBookingLink}"));
  }, [tplContent]);

  useEffect(() => {
    getManualSmsTemplates().then((data) => {
      setTemplates(data);
      let orderedTemplates = orderBy(data, ["name"], ["asc"]);
      setTplOptions(orderedTemplates.map((tpl) => ({ label: tpl.name, value: tpl.name })));
      setTplSelectedOptions(orderedTemplates.map((tpl) => ({ label: tpl.name, value: tpl.name })));
    });
  }, []);

  const handleChangeTemplate = (t) => {
    const selected = templates.find((tpl) => tpl.name === t.value);
    setTplContent(selected.content);
  };

  const handleChangeContent = (e) => {
    setErrorMessage(null);
    setTplContent(e.target.value);
  };

  const handleInputChange = (characterEntered) => {
    if (characterEntered === "") return;
    setTplOptions([{ label: characterEntered, value: characterEntered }, ...tplOptions]);
  };

  const handleClickSend = () => {
    setErrorMessage(null);
    /* eslint-disable no-template-curly-in-string */
    if (tplContent.includes("${patientBookingLink}") && _.isEmpty(selectedSMSTemplateSetId)) {
      setErrorMessage("The sms template set id can not be empty.");
      return;
    }
    onSend(
      tplContent.replace(
        "${patientBookingLink}",
        "${patientBookingLink}".concat(`?smsTemplateId=${selectedSMSTemplateSetId || ""}`)
      )
    );
    /* eslint-disable no-template-curly-in-string */
  };

  useEffect(() => {
    getAllSMSTemplates({ type: "appointment_auto_sms" }).then((response) => {
      const sortedTemplates = response.result.sort(smsTemplatesSorter);
      setTemplateSets(sortedTemplates);
    });
  }, []);

  const getSMSTemplatesOptions = (templateSets) => {
    return templateSets
      .map(({ name, id }) => {
        if (name === "RT" && !isRTNoteFilled) {
          return null;
        }

        return { label: name, value: id };
      })
      .filter((set) => !_.isEmpty(set));
  };

  return (
    <div className="columns">
      <div className="column is-one-third">
        <Select
          className="has-text-left is-radiusless is-size-7"
          components={{ Input }}
          onInputChange={handleInputChange}
          onChange={handleChangeTemplate}
          options={tplSelectedOptions}
          placeholder="please input sms template"
          styles={customSelectStyles}
        />
        <textarea
          className="textarea is-radiusless is-size-7"
          placeholder="e.g. Hello world"
          value={tplContent}
          onChange={handleChangeContent}
        />
        {showBookingSMSTemplateSetsDropdown && (
          <SelectField
            label="Auto SMS Template Sets"
            isRequired={true}
            value={selectedSMSTemplateSetId}
            onChange={(e) => setSelectedSMSTemplateSetId(e.target.value)}
            options={getSMSTemplatesOptions(templateSets)}
          />
        )}
        <div className="send">
          <Button text="Send" isLoading={isSending} onClick={handleClickSend} />
          {errorMessage && <p className="has-text-danger">{errorMessage}</p>}
        </div>
      </div>
    </div>
  );
};

export default ManualSms;
